import { FC } from "react";
import { Tabs } from "@rothoblaas/design-system";
import useI18n from "../../../../hooks/useTranslations";
import AdminSupportFamilies from "./AdminSupportFamilies";
import AdminSupports from "./AdminSupports";

const AdminSupportsTabs: FC = () => {
  const i18n = useI18n();

  return (
    <Tabs.SubTab>
      <Tabs
        urlParameter="supports_tab"
        tabs={[
          { title: i18n.translation.deckDesignerModule.supports.plural },
          { title: i18n.translation.deckDesignerModule.supportFamilies.plural },
        ]}
        contents={[<AdminSupports />, <AdminSupportFamilies />]}
      />
    </Tabs.SubTab>
  );
};

export default AdminSupportsTabs;
